export const EN = {
    cancel: "Cancel",
    submit: "Submit",
    message: "Message",
    feedback: "Feedback",
    tooltipLabel: "For feedback please click here",
    tooltipText: "Feedback",
    feedbackSuccessfullySent: "Thank you very much! The feedback was sent successfully.",
    close: "Close",
    error: {
        sendingFailed: "We couldn't process your feedback - sorry :-(. If you'd like, please contact support@21re.de instead.",
        unauthorized: "You must be logged in to use this form. If you'd like, please contact support@21re.de instead.",
    },
};
//# sourceMappingURL=en.js.map